import React, { createContext, useContext, useState, useEffect } from 'react';
import { en } from '../locales/en';
import { ro } from '../locales/ro';

const LanguageContext = createContext();

export const translations = { en, ro };

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
  // Default to Romanian ('ro') for new visitors; existing users keep their saved preference.
  return localStorage.getItem('appLanguage') || 'ro';
  });

  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    if (!value) return key; // Added guard against undefined language object
    
    for (const k of keys) {
      if (value[k] === undefined) return key;
      value = value[k];
    }
    return value;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ro' : 'en');
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
